import React, {useMemo} from 'react'
import moments from 'moment'

const yesNoFromValue = (value: any) => {
    if (value === 1 || value === '1' || value === 'DA') return 'DA'
    return 'NE'
}

const SCAN_KEYS = [
    'ROLNA-G-SKENIRANA',
    'ROLNA-D-SKENIRANA',
    'TRAKA-G-SKENIRANA',
    'TRAKA-D-SKENIRANA',
]

const KomponentiPregled = ({data, stavkeData}) => {
    const items = useMemo(() => {
        if (!Array.isArray(stavkeData)) return []
        return [...stavkeData].sort(
            (a, b) => new Date(b.Kreirano).getTime() - new Date(a.Kreirano).getTime()
        )
    }, [stavkeData])

    return (
        <div className='card shadow-sm'>
            {/* HEADER */}
            <div className='card-header bg-white py-3'>
                <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
                    <div>
                        <h4 className='mb-1 fw-bold'>Komponente</h4>
                        <div className='text-muted fs-6'>
                            Pregled aktivnosti na nalogu
                        </div>
                    </div>

                    <span className='badge bg-light text-dark border fs-6 px-3 py-2'>
            Nalog: <strong>{data?.BrojNaloga ?? '—'}</strong>
          </span>
                </div>
            </div>

            <div className='card-body pt-4'>
                {/* SUMMARY */}
                <div className='row g-3 mb-4'>
                    <div className='col-12 col-lg-6'>
                        <div className='border rounded-3 p-3 bg-light h-100'>
                            <div className='row g-3'>
                                <div className='col-6'>
                                    <div className='text-muted fs-6'>Stavka</div>
                                    <div className='fw-semibold fs-5'>{data?.Stavka ?? '—'}</div>
                                </div>
                                <div className='col-6'>
                                    <div className='text-muted fs-6'>Smjena</div>
                                    <div className='fw-semibold fs-5'>{data?.Smjena ?? '—'}</div>
                                </div>
                                <div className='col-6'>
                                    <div className='text-muted fs-6'>Mašina</div>
                                    <div className='fw-semibold fs-5'>{data?.Masina ?? '—'}</div>
                                </div>
                                <div className='col-6'>
                                    <div className='text-muted fs-6'>Kupac</div>
                                    <div className='fw-semibold fs-5'>
                                        {data?.paneli_proizvodnja?.kupac ?? '—'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-12 col-lg-6'>
                        <div className='border rounded-3 p-3 bg-light h-100'>
                            <div className='row g-3'>
                                <div className='col-12'>
                                    <div className='text-muted fs-6'>Artikal</div>
                                    <div className='fw-semibold fs-5'>
                                        {data?.paneli_proizvodnja?.artikal ?? '—'}
                                    </div>
                                </div>
                                <div className='col-12'>
                                    <div className='text-muted fs-6'>Komercijalista</div>
                                    <div className='fw-semibold fs-5'>
                                        {data?.paneli_proizvodnja?.kreiraoKorisnik ?? '—'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* LIST HEADER */}
                <div className='d-flex justify-content-between align-items-center mb-3'>
                    <div className='fw-bold fs-4'>Evidencija zapisa</div>
                    <div className='text-muted fs-6'>Novi zapisi na vrhu</div>
                </div>

                {/* LIST */}
                {items.length === 0 ? (
                    <div className='alert alert-info fs-5 mb-0'>
                        Nema unesenih stavki.
                    </div>
                ) : (
                    <div className='list-group list-group-flush'>
                        {items.map((item, idx) => {
                            const date = moments(item.Kreirano).format('DD.MM.YYYY HH:mm')
                            let value = item.MetaValue

                            // ✅ handle Rolna + Traka scanned flags
                            if (SCAN_KEYS.includes(item.MetaKey)) {
                                value = yesNoFromValue(item.MetaValue)
                            }

                            const isYes = value === 'DA'
                            const isNo = value === 'NE'

                            return (
                                <div
                                    key={idx}
                                    className='list-group-item px-3 py-3'
                                >
                                    <div className='d-flex flex-wrap align-items-center gap-3'>
                                        {/* DATE */}
                                        <span className='text-muted fs-6'>
                      {date}
                    </span>

                                        {/* META KEY */}
                                        <span className='badge bg-light text-dark border fs-6 px-3 py-2'>
                      {item.MetaKey}
                    </span>

                                        {/* META VALUE */}
                                        <span
                                            className={`
                        badge fs-6 px-3 py-2
                        ${
                                                isYes
                                                    ? 'bg-success-subtle text-success'
                                                    : isNo
                                                        ? 'bg-danger-subtle text-danger'
                                                        : 'bg-secondary-subtle text-dark'
                                            }
                      `}
                                        >
                      {value}
                    </span>

                                        {/* USER */}
                                        <span className='ms-auto fs-6 text-muted fw-semibold'>
                      {item?.uposlenik?.UposlenikImePrezime ?? '—'}
                    </span>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                )}
            </div>
        </div>
    )
}

export default KomponentiPregled
